module.exports = __webpack_public_path__ + "static/img/sale.2f4d33d7.png";